import { useEffect, useState } from 'react';
import { chatService } from '../services/chatService';

export function useUnreadMessageCount(): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let mounted = true;
    const refresh = async () => {
      try {
        const threads = await chatService.getThreads();
        if (mounted) setCount(threads.reduce((total, thread) => total + (thread.unread_count_hotel || 0), 0));
      } catch {
        // Navigation should remain usable when messaging is temporarily unavailable.
      }
    };

    refresh();
    const timer = window.setInterval(refresh, 15000);
    return () => {
      mounted = false;
      window.clearInterval(timer);
    };
  }, []);

  return count;
}
